<template>
  <v-app id="inspire" class="grey lighten-3">
   <PublicNavbar/>
   <v-main>
     <v-flex>
        <v-container
        fluid
      >
        <v-layout px-5  row class="mt-1">
          <v-flex xs10 dense>
            <div class="subtitle" style=" font-size: 0.92em;">Dashboard</div>
          </v-flex>
          <v-flex class="text-right" xs2 >
            <v-spacer/>
             <v-breadcrumbs class="pa-0" :items="crumbItems" id="crumbs">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item :href="item.href" :disabled="item.disabled" @click="breadCrumbClick(item)" style=" font-size: 0.92em;">
                  {{item.text}}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 pa-5>
            <v-card
              tile
              class="mx-auto"
            >
            <v-flex>
            <v-progress-linear
              id="progress"
              color="#009933"
              height="3.5"
              indeterminate
              :active="loading"
            />
            </v-flex>
              <v-list>
                <v-list-item-content>
                  <v-list-item-subtitle :v-model="name" class="pl-4 pb-4"  style=" font-size: 0.92em;">
                    <span>{{name}}</span>
                    <v-icon
                      @click="fullscreen"
                      @mouseenter="shortcutSnackbar = true"
                      @mouseleave="shortcutSnackbar = false"
                      style="float: right;"
                      color="green"
                      class=" pr-7" >
                        mdi-presentation
                    </v-icon>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content class="ml-6 mr-6"  >
                 <div v-if="!mobileCheck" id="embedContainer" style="height:90vh; border: 0px;" ></div>
                 <div v-if="mobileCheck" id="embedContainer" style=" height: 40vh; border: 0px;" ></div>
                 <div style="text-align: center;" class="mt-2">
                    <v-btn
                      color="#339966"
                      class="text-none pa-4 mt-2 mb-4 ml-2"
                      dark
                      tile
                      style="font-size: 0.8em;"
                      @click="fullscreen">
                      Enter fullscreen mode
                    </v-btn>
                </div>
                </v-list-item-content>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-snackbar
        id="snack"
        color="#339966"
        v-model="snackbar"
        center
        style="position: fixed; "
        class="mb-6 ma-19"
      >
        <v-layout class="pa-2">
          <span name="app" dark style=" font-size: 0.88em;"><v-icon color="white"> {{snackbarError.icon}}</v-icon> {{snackbarError.label}}  </span>
          <v-spacer/>
        </v-layout>
      </v-snackbar>
      <v-snackbar
        id="snack"
        color="black"
        timeout="-1"
        v-model="shortcutSnackbar"
        right
        style="position: fixed; width: 200px; max-width: 200px; "
        class="mb-6 ma-19"
      >
        <span
          style=" font-size: 0.82em;"
        >
          Tip: Press ctrl+shift+f to enter fullscreen mode
        </span>
      </v-snackbar>
     </v-flex>
   </v-main>
  </v-app>
</template>

<script>
import PublicNavbar from '@/components/PublicNavbar'
import * as pbi from 'powerbi-client'
import { isMobile } from 'mobile-device-detect'
export default {
  data: () => {
    return {
      fullscreenPattern: [],
      feedback: '',
      rating: 0,
      items: [],
      userIds: null,
      message: '',
      feedbackDialog: false,
      ratingDialog: false,
      recommendationDialog: false,
      reportId: '',
      datasetId: '',
      mobileCheck: isMobile,
      loading: true,
      snackbar: false,
      shortcutSnackbar: false,
      feedbackLoader: false,
      hasFeedback: false,
      name: '',
      crumbItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/'
        },
        {
          text: 'Public Reports',
          disabled: false,
          href: '/publicCardReports'
        },
        {
          text: 'Report',
          disabled: false,
          href: '/publicPowerBiVisual'
        }
      ],
      snackbarError: { icon: 'mdi-server-network-off', label: 'A system error occurred, please try again.' }
    }
  },
  components: {
    PublicNavbar
  },
  methods: {
    pageChange () {
      var viewershipId = localStorage.getItem('viewershipId')
      window.axios.post('/viewership/updatePageChangePublic', { id: viewershipId })
        .then(() => {
        })
    },
    visualClick () {
      var viewershipId = localStorage.getItem('viewershipId')
      window.axios.post('/viewership/updateVisualClickPublic', { id: viewershipId })
        .then(() => {
        })
    },
    fullscreen () {
      // check if fullscreen mode is available
      if (document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled) {
        // which element will be fullscreen
        var iframe = document.querySelector('#embedContainer iframe')
        // Do fullscreen
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen()
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen()
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen()
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen()
        }
      } else {
        document.querySelector('.error').innerHTML = 'Your browser is not supported'
      }
    },
    breadCrumbClick (item) {
      this.$router.push(item.route).catch(() => {
        window.location.reload()
      })
    }
  },
  mounted: [
    async function () {
      const passphrase = process.env.VUE_APP_PASSPHRASE

      const encryptedName = localStorage.getItem('name')
      this.name = await this.CryptoJS.AES.decrypt(encryptedName, passphrase).toString(this.CryptoJS.enc.Utf8)

      var encryptedAccessToken = localStorage.getItem('tken')
      var encryptedEmbedUrl = localStorage.getItem('embUrl')
      var encryptedEmbedReportId = localStorage.getItem('reportId')
      const encryptedDatasetId = localStorage.getItem('datasetId')

      const txtAccessToken = await this.CryptoJS.AES.decrypt(encryptedAccessToken, passphrase).toString(this.CryptoJS.enc.Utf8)
      const txtEmbedUrl = await this.CryptoJS.AES.decrypt(encryptedEmbedUrl, passphrase).toString(this.CryptoJS.enc.Utf8)
      const txtEmbedReportId = await this.CryptoJS.AES.decrypt(encryptedEmbedReportId, passphrase).toString(this.CryptoJS.enc.Utf8)
      const txtDatasetId = await this.CryptoJS.AES.decrypt(encryptedDatasetId, passphrase).toString(this.CryptoJS.enc.Utf8)
      this.reportId = txtEmbedReportId

      // Read embed type from radio
      var models = pbi.models
      // We give All permissions to demonstrate switching between View and Edit mode and saving report.
      var permissions = models.Permissions.All
      // Embed configuration used to describe the what and how to embed.
      var config = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: txtAccessToken,
        embedUrl: txtEmbedUrl,
        id: txtEmbedReportId,
        permissions: permissions,
        settings: {
          panes: {
            filters: {
              visible: true
            },
            pageNavigation: {
              visible: true
            }
          }
        }
      }
      let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory)
      // Get a reference to the embedded report HTML element
      var embedContainer = document.getElementById('embedContainer')
      // Embed the report and display it within the div container.
      var report = powerbi.embed(embedContainer, config)
      // Report.off removes a given event handler if it exists.
      report.off('loaded')
      report.on('loaded', function () {
        parent.document.getElementById('progress').style.visibility = 'hidden'
      })
      // Report.off removes a given event handler if it exists.
      report.off('rendered')
      report.on('rendered', function () {
      })
      report.on('error', (event) => {
        parent.document.getElementById('progress').style.visibility = 'hidden'
        const message = event.detail.message
        if (message === 'TokenExpired') {
          // get the refresh embed token
          window.axios.post('/viewership/getEmbedToken', { reportId: txtEmbedReportId, datasetId: txtDatasetId })
            .then(async (response) => {
              const token = response.data.token
              const encryptedToken = this.$CryptoJS.AES.encrypt(token, passphrase).toString()
              localStorage.setItem('tken', encryptedToken)
              window.location.reload()
            })
            // eslint-disable-next-line handle-callback-err
            .catch(() => {
            })
        }
      })
      report.off('saved')
      report.on('saved', function () {
        // if (event.detail.saveAs) {
        // }
      })
      report.off('visualClicked')
      report.on('visualClicked', () => {
        // console.log('clicked')
        this.visualClick()
      })
      report.off('pageChanged')
      report.on('pageChanged', () => {
        // console.log('pageChanged', event)
        this.pageChange()
      })
    },
    // listen for full screen key presses
    function () {
      document.addEventListener('keydown', (event) => {
        // listen for the following keys to go into fullscreen mode
        // Control, Shift & F
        // this.fullscreen()
        // and only add the key if its not available
        const keyCheck = this.fullscreenPattern.some((data) => {
          return data === event.key
        })
        var patternSize = this.fullscreenPattern.length

        if (patternSize <= 3 && !keyCheck && (event.key === 'Control' || event.key === 'Shift' || event.key === 'F')) {
          this.fullscreenPattern.push(event.key)
          // check if the Ctrl, Shift & F pattern was pressed
          // console.log('added ---->', event.key)
          patternSize = this.fullscreenPattern.length
          if (patternSize === 3 && this.fullscreenPattern[0] === 'Control' && this.fullscreenPattern[1] === 'Shift' && this.fullscreenPattern[2] === 'F') {
            this.fullscreen()
          }
        }
        // console.log(this.fullscreenPattern)
      })

      document.addEventListener('keyup', (event) => {
        // listen for the following keys to go into fullscreen mode
        // Control, Shift & F
        // this.fullscreen()
        if (event.key === 'Control' || event.key === 'Shift' || event.key === 'F') {
          // remove the key from the pattern
          const size = this.fullscreenPattern.length

          for (let i = 0; i < size; i++) {
            const key = this.fullscreenPattern[i]

            // if it there remove it
            if (event.key === key) {
              this.fullscreenPattern.splice(i, 1)
              break
            }
          }
        }
      })
    }
  ]
}
</script>

<style scoped>

.v-text-field >>> input {
  font-size: 0.86em;
}
.v-text-field >>> label {
  font-size: 0.86em;
}

#crumbs{
  align-content: right;
  justify-content: right;
}
#powerBiFrame{
  padding-left: 2%;
  padding-right: 2%;
  padding-top: 2%;
}
</style>
